<div class="d-flex flex-row">
  <a class="back-btn d-flex justify-content-center align-items-center" (click)="back()">
    <svg width="8px" height="20px" viewBox="0 0 19 41" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <defs></defs>
      <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Arrow/Left" transform="translate(-12.000000, -4.000000)" fill="#000000">
          <path d="M28.949609,44.5859918 L12,24.4995264 L28.949609,4.41407071 C29.3745432,3.90817291 30.1162287,3.86071343 30.6006146,4.29996602 C31.0869498,4.74022838 31.1356807,5.50563864 30.7107466,6.00951689 L15.1061126,24.4995264 L30.7107466,42.9905456 C31.1356807,43.4944239 31.0869498,44.2598341 30.6006146,44.6990867 C30.3784013,44.9000322 30.1045332,45 29.8306651,45 C29.5051422,45 29.1815685,44.8596411 28.949609,44.5859918 Z" id="Fill-1"></path>
        </g>
      </g>
    </svg>
  </a>
  <div class="d-flex breadcumb-container">
    <div class="row flex-g1">
      <div class="col-md-12 col-sm-12">
        <div class="row">
          <div class="col-md-8 col-sm-8">
            <div class="row">
              <div class="col-md-12 col-sm-12 breadcumb-header">
                <div class="d-flex flex-row flex-wrap">
                  <div *ngFor="let menu of elementPaths; let i = index" class="d-flex flex-row align-items-center">
                    <a class="not-underline" [ngClass]="{'first-line text-semi-bold-font': i === 0, 'first-line text-light-font': i > 0}"
                       [routerLink]="[menu.link]"
                       [queryParams]="{activeAccount: activeAccount}"
                       queryParamsHandling="merge">{{menu.name}}</a>
                    <img *ngIf="shouldShowArrowRight(i)" src="assets/images/Arrow_Right.svg" width="13" height="17" class="breadcumb-seperate-arrow"/>
                    <img *ngIf="shouldShowEditIcon(i)"
                         actionByLevels="Auto update groups"
                         [wallName]="'Advanced Groups'"
                         [actionData]="invalidActionData"
                         (afterChecking)="editInfluencerGroupSetting()"
                         placement="bottom"
                         ngbTooltip="{{'info_box.group_details.config' | translate}}"
                         src="assets/images/Edit_Icon.svg" width="18" height="18" class="ml-2 edit-icon"/>
                    <div class="d-flex flex-row align-items-center close-setting"
                         *ngIf="shouldShowCloseSettingIcon(i)"
                         actionByLevels="Auto update groups"
                         [wallName]="'Advanced Groups'"
                         [actionData]="invalidActionData"
                         (afterChecking)="closeSetting()">
                      <img src="assets/images/Add_Icon.svg" width="18" height="18" class="icon-close"/>
                      <a (click)="closeSetting()">{{'group_details.close_setting' | translate}}</a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-sm-12 breadcumb-subheader mt-5px">
                <span>{{influencerGroup.influencer_group_description || 'group_influencers.no-description' | translate}}</span>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-4  d-flex justify-content-end">
            <div class="search-box-container">
              <achoo-text-field placeholder="{{'group_details.search_placeholder' | translate}}"
                                [isPageSearch]="true"
                                [(model)]="searchString"
                                (modelChange)="onSearchText($event)"
                                placement="bottom"
                                ngbTooltip="{{'info_box.group_details.search' | translate}}">
              </achoo-text-field>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 breadcumb-summarize mt-4px">
        <span class="total-influencers-count">{{totalResult}}</span>
      </div>
      <div class="col-md-12 col-sm-12 group-setting-section" [ngClass]="{'collapsed': showGroupSetting === false}">
        <new-group-settings *ngIf="openNewGroupSetting" #NewGroupSetting
                            [influencerGroup]="groupSetting"
                            [listProject]="listProjectOfAdvertiser"
                            (updateGroupEvent)="updateGroup($event)"
                            (editOrCreateProjectEvent)="editOrCreateProject($event)"
                            (beforeSubmitGroupSetting)="beforeSubmitGroupSetting()"
                            (afterSubmitGroupSetting)="afterSubmitGroupSetting($event)">
        </new-group-settings>
      </div>
    </div>
  </div>
</div>
<achoo-popup #SaveGroupSettingError
             [isNotification]="true"
             modelTitle="{{'notification.error' | translate}}">
  <span>{{'new_group_settings.save_group_setting_failed' | translate}}</span>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/group-details/group-details-breadcumb/group-details-breadcumb.component.html